import { Link } from "gatsby"
import React from "react"

export default function Navbar() {
  return (
    <nav>
      <Link to="/">
        <img src="/acm_logo.png" alt="ACM PCCOER" />
      </Link>
      <div className="links">
        <Link to="/about">About</Link>
        <Link to="/events">Events</Link>
        <Link to="/blogs">Blogs</Link>
        <Link to="/team">Team</Link>
      </div>
    </nav>
  )
}
